import { render, staticRenderFns } from "./BriefList.vue?vue&type=template&id=fff36b00&scoped=true"
import script from "./BriefList.vue?vue&type=script&lang=js"
export * from "./BriefList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff36b00",
  null
  
)

export default component.exports